import React from "react";
import { RatePolicies } from "views/Status/Policies/Rate/component";

const returnView = "viewRulesRate";

export const SubscriberRatesPoliciesTable = () => (
  <div className="row clearfix">
    <RatePolicies returnView={returnView} />
  </div>
);

export default SubscriberRatesPoliciesTable;
